/**
 * Shared label + control row for Binom offer + lander edit dialogs.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

export interface OfferEditFieldProps {
  label: string;
  children: ReactNode;
}

const OfferEditField: FC<OfferEditFieldProps> = ({ label, children }) => (
  <div className="grid grid-cols-[7rem_minmax(0,1fr)] items-center gap-2">
    <label className="text-right text-xs font-medium text-muted-foreground">
      {label}
    </label>
    <div className="min-w-0">{children}</div>
  </div>
);

export default OfferEditField;
